"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function flashSuccess(msg) {
    Reverb.UI.flashSuccess(msg);
}
exports.flashSuccess = flashSuccess;
function flashError(msg) {
    Reverb.UI.flashError(msg);
}
exports.flashError = flashError;
//# sourceMappingURL=flash.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/flash.js
// module id = 3Q/e
// module chunks = 20 21